import {useMutation} from '@tanstack/react-query';
import {API, type CreateEsimOrderRequestPayload} from '@chekin/api';
import {useIsMounted} from '@chekin/guestapp-ui-kit';
import {EsimOrder} from '@chekin/core';

type Props = {
  onError?: (error: Error) => void;
  onSuccess?: () => void;
};
function useMutateEsimOrders({onError, onSuccess}: Props = {}) {
  const isMounted = useIsMounted();

  return useMutation<
    PromiseSettledResult<EsimOrder>[],
    Error,
    CreateEsimOrderRequestPayload[]
  >({
    mutationFn: requests =>
      Promise.allSettled(requests.map(request => API.upselling.createEsimOrder(request))),
    onError: error => {
      if (!isMounted.current) {
        return;
      }
      onError?.(error);
    },
    onSuccess,
  });
}

export {useMutateEsimOrders};
